<div class="main-container">
  <div class="full-container">     <!-- Header text content-->
    <div class="content-section">
      <h1 class="dome">
        <p>DOME <span>Registry</span>
        </p>
      </h1>

      <div class="dome-text">
        A database of annotations for published papers describing machine learning methods in biology.
      </div>

      <div class="metrics-container">
        <div class="icons-container">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
              <g clip-path="url(#clip0_1_15682)">
                <path
                  d="M2.75342 50.1613V47.6775C2.75342 38.0752 10.5376 30.291 20.1399 30.291V30.291C29.7422 30.291 37.5264 38.0752 37.5264 47.6775V50.1613"
                  stroke="white" stroke-width="3.72567" stroke-linecap="round"/>
                <path
                  d="M32.5586 35.2585V35.2585C32.5586 28.3997 38.1187 22.8396 44.9775 22.8396V22.8396C51.8363 22.8396 57.3964 28.3997 57.3964 35.2585V36.5004"
                  stroke="white" stroke-width="3.72567" stroke-linecap="round"/>
                <path
                  d="M20.1397 30.2909C25.6267 30.2909 30.0749 25.8428 30.0749 20.3558C30.0749 14.8688 25.6267 10.4207 20.1397 10.4207C14.6527 10.4207 10.2046 14.8688 10.2046 20.3558C10.2046 25.8428 14.6527 30.2909 20.1397 30.2909Z"
                  stroke="white" stroke-width="3.72567" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                  d="M44.9777 22.8397C49.093 22.8397 52.4291 19.5036 52.4291 15.3884C52.4291 11.2731 49.093 7.93701 44.9777 7.93701C40.8624 7.93701 37.5264 11.2731 37.5264 15.3884C37.5264 19.5036 40.8624 22.8397 44.9777 22.8397Z"
                  stroke="white" stroke-width="3.72567" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_1_15682">
                  <rect width="59.6108" height="59.6108" fill="white" transform="translate(0.269531 0.485596)"/>
                </clipPath>
              </defs>
            </svg>
            <div>
              <span>Users</span>
              <p>{{ countUsers$ | async }}</p>
            </div>
          </div>
        </div>
        <div class="small-white-line"></div>

        <div class="icons-container">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
              <path
                d="M50.5484 30.291V14.7716C50.5484 14.3766 50.3915 13.9977 50.1122 13.7184L42.2959 5.90209C42.0165 5.62275 41.6377 5.46582 41.2426 5.46582H12.3176C11.495 5.46582 10.8281 6.1327 10.8281 6.95533V53.6267C10.8281 54.4493 11.495 55.1162 12.3176 55.1162H28.2058"
                stroke="white" stroke-width="3.72378" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.7583 25.3258H40.6184M20.7583 15.3958H30.6884M20.7583 35.2559H28.2059" stroke="white"
                    stroke-width="3.72378" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                d="M45.4693 42.5532L47.9518 40.0707C49.0389 38.9836 50.8015 38.9836 51.8886 40.0707V40.0707C52.9757 41.1578 52.9757 42.9203 51.8886 44.0074L49.406 46.49M45.4693 42.5532L38.0439 49.9786C37.6717 50.3508 37.4275 50.8315 37.3464 51.3515L36.7439 55.2153L40.6075 54.613C41.1275 54.5319 41.6083 54.2876 41.9805 53.9155L49.406 46.49M45.4693 42.5532L49.406 46.49"
                stroke="white" stroke-width="3.72378" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M40.6182 5.46582V13.9064C40.6182 14.729 41.285 15.3959 42.1077 15.3959H50.5482"
                    stroke="white" stroke-width="3.72378" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <span>Entries</span>
              <p>{{ count$ | async }}</p>
            </div>
          </div>
        </div>
        <div class="small-white-line"></div>
        <div class="icons-container">
          <div class="icon">
            <i class="bi bi-file-earmark-lock bootstrap-icon"></i>
            <div>
              <span>Private</span>
              <p>{{ countPr$ | async }}</p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <a class="custom-button gradient-button" [routerLink]="['/search']">Browse
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </div>
    </div>
    <div class="custom-container">

      <img class="brain" src="../../assets/logo-white-animated.svg" alt="DOME Registry Logo" decoding="async"/>
      <div class="beams">
        <div class="beam-container" id="D">
          <img class="beam" src="../../assets/Group-209.svg" alt="Data" loading="lazy" decoding="async"/>
          <p>D<span>ATA</span></p>
        </div>
        <div class="beam-container" id="O">
          <img class="beam" src="../../assets/Group-47.svg" alt="Optimization" loading="lazy" decoding="async"/>
          <p>O<span>PTIMIZATION</span></p>
        </div>
        <div class="beam-container" id="M">
          <img class="beam" src="../../assets/Group-45.svg" alt="Model" loading="lazy" decoding="async"/>
          <p>M<span>ODEL</span></p>
        </div>
        <div class="beam-container" id="E">
          <img class="beam" src="../../assets/Group-46.svg" alt="Evaluation" loading="lazy" decoding="async"/>
          <p>E<span>VALUATION</span></p>
        </div>
      </div>

    </div>
  </div>
  <div class="latest-publications">
    <h2>LATEST PUBLISHED ANNOTATIONS</h2>
    <div class="cards-container">
      <button class="scroll-button scroll-left" (click)="scrollLeft()" aria-label="Scroll left">
        <i class="bi bi-chevron-left" aria-hidden="true"></i>
      </button>
      <div class="cards" #cardsContainer>
        <div *ngFor="let review of latestReviews$ | async; trackBy: trackByShortId"
             class="publications-card"
             [routerLink]="['/review', review.shortid]">
          <div class="publication-header">
            <p>{{ review.journal }}</p>
          </div>
          <div class="publication-body">
            <p>
              {{ review.title.length > 80 ? review.title.substring(0, 80) + '...' : review.title }}
            </p>
            <span>
            {{ review.authors.length > 80 ? review.authors.substring(0, 80) + '...' : review.authors }}
          </span>
          </div>
          <div class="score">
            <app-score [dataScore]="review.score"></app-score>
          </div>
        </div>
      </div>
      <button class="scroll-button scroll-right" (click)="scrollRight()" aria-label="Scroll right">
        <i class="bi bi-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>
